// src/beta/components/slides/GallerySlide.tsx
import type { V1Slide } from '@/beta/types/story';

interface Props { slide: V1Slide; }

/** Gallery slide — Phase G renders the first image full-bleed with a "1 / N"
 *  counter in the top-right. A future phase can swap to a grid/carousel. */
export function GallerySlide({ slide }: Props) {
  const images = slide.block.galleryImages ?? [];
  if (images.length === 0) return <div style={{ width: '100%', height: '100%', background: '#000' }} />;

  const first = images[0];
  const src = first.mediumUrl ?? first.url ?? first.thumbnailUrl ?? '';

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', background: '#000' }}>
      {src && (
        <img
          src={src}
          alt="Gallery image"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      )}

      <div
        style={{
          position: 'absolute',
          top: 'var(--vm-s-3)',
          right: 'var(--vm-s-3)',
          color: 'var(--vm-warm-white)',
          fontFamily: 'var(--vm-font-heading)',
          fontSize: 12,
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          padding: '8px 14px',
          border: '1px solid var(--vm-stone)',
          background: 'rgba(0,0,0,0.5)',
        }}
      >
        1 / {images.length}
      </div>
    </div>
  );
}
